//============================
//# mlsysisync_partner
//# Partnertörzs interfész szinkron köztes tábla
//============================
import IfaceSync from "./IfaceSync";

export default interface IfaceSyncPartner extends IfaceSync {
    /** Belső partenr azonosító (mlgenpartner.szam) */
    partner: number;
    /** Külső azonosító2 (pl.: incadea esetén a "key" lesz az ext_code a "no" pedig a 2. azonosító) */
    extCode2: string | null;
    /** Belföldi adószám/adóazonosító jel */
    taxaccount: string | null;
    /** Közösségi adószám */
    euTaxaccount: string | null;
    /** Név */
    name: string | null;
    /** Levelezési név */
    corName: string | null;
    /** Jó esetben 2 vagy 3 betűs ország kód (HU/HUN) */
    countryCode: string | null;
    /** Jó esetben 2 vagy 3 betűs nyelv kód (HU/HUN) */
    languageCode: string | null;
    /** Irányítószám */
    postcode: string | null;
    /** Levelezési irányítószám */
    corPostcode: string | null;
    /** Város megnevezés */
    city: string | null;
    /** Levelezési város megnevezés */
    corCity: string | null;
    /** Cím */
    address: string | null;
    /** Levelezési cím */
    corAddress: string | null;
    /** Kapcsolattartó személy */
    contact: string | null;
    /** Telefonszám */
    phoneNo: string | null;
    /** Fax */
    faxNo: string | null;
    territoryCode: string | null;
    departmentCode: string | null;
    /** Speciális adózás típúsa */
    specTaxType: string | null;
    /** Alapértelmezett pénznem */
    currencyCode: string | null;
}

export const IfaceSyncPartnerDefaultProps: IfaceSyncPartner = {
    id: 1,
    extCode: '',
    interface: 1,
    syncStatus: 1,
    errorText: null,
    syncRemark: null,
    userModified: false,
    insDate: new Date(),
    insTime: new Date(),
    insUserId: 1,
    updDate: new Date(),
    updTime: new Date(),
    updUserId: 1,
    partner: 0,
    extCode2: null,
    taxaccount: null,
    euTaxaccount: null,
    name: null,
    corName: null,
    countryCode: null,
    languageCode: null,
    postcode: null,
    corPostcode: null,
    city: null,
    corCity: null,
    address: null,
    corAddress: null,
    contact: null,
    phoneNo: null,
    faxNo: null,
    territoryCode: null,
    departmentCode: null,
    specTaxType: null,
    currencyCode: null,
}
